// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ysT5c7NXUG3trnVkV56w{padding:0 14px;display:flex;flex-direction:column;flex-grow:1;justify-content:space-between}`, "",{"version":3,"sources":["webpack://./src/pages/Web/PartnerLink/PartnerLinkPage.module.scss"],"names":[],"mappings":"AAAA,sBACE,cAAA,CACA,YAAA,CACA,qBAAA,CACA,WAAA,CACA,6BAAA","sourcesContent":[".partnerLinkPage {\n  padding: 0 14px;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"partnerLinkPage": `ysT5c7NXUG3trnVkV56w`
};
export default ___CSS_LOADER_EXPORT___;
